// src/market/warehouse-baserow/useMail.jsx
import { useState, useCallback } from "react";

const useMail = () => {
  const [sending, setSending] = useState(false);
  const [mailError, setMailError] = useState(null);
  const [mailSuccess, setMailSuccess] = useState(null);

  // URL absoluta a tu archivo send.php
  const endpoint = "https://fisiofitnessapp.com/mail/send.php"; // ← cámbialo por el real

  const sendReservationConfirmation = useCallback(
    async (nombre, email, clase, horario) => {
      console.log("📨 Enviando correo con reserva:", {
        nombre,
        email,
        clase,
        horario,
      });

      setSending(true);
      setMailError(null);
      setMailSuccess(null);

      try {
        const params = new URLSearchParams({
          nombre,
          email,
          clase,
          horario,
        });

        const fullUrl = `${endpoint}?${params.toString()}`;
        console.log("🔗 URL generada:", fullUrl);

        const response = await fetch(fullUrl);
        const text = await response.text();

        console.log("📥 Respuesta del servidor:", text);

        if (!response.ok) {
          console.error("❌ Error HTTP:", response.status);
          throw new Error(text || "Error al enviar el correo");
        }

        setMailSuccess(text);
      } catch (error) {
        console.error("🚨 Error al enviar correo:", error.message);
        setMailError(error.message);
      } finally {
        console.log("🔚 Finalizado el intento de envío");
        setSending(false);
      }
    },
    [endpoint]
  );

  // Notificar la cancelación de la clase.
  const notifyClassCancellation = useCallback(async (clase, emails = []) => {
    console.log("📨 Enviando notificación de clase cancelada:", {
      clase,
      emails,
    });

    setSending(true);
    setMailError(null);
    setMailSuccess(null);

    try {
      const response = await fetch(
        "https://fisiofitnessapp.com/mail/deleted_class.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ clase, emails }),
        }
      );

      const text = await response.text();
      console.log("📥 Respuesta del servidor:", text);

      if (!response.ok) {
        console.error("❌ Error HTTP:", response.status);
        throw new Error(text || "Error al enviar notificación");
      }

      setMailSuccess(text);
    } catch (error) {
      console.error("🚨 Error al notificar cancelación:", error.message);
      setMailError(error.message);
    } finally {
      console.log("🔚 Finalizado intento de notificación");
      setSending(false);
    }
  }, []);

  return {
    sendReservationConfirmation,
    notifyClassCancellation,
    sending,
    mailError,
    mailSuccess,
  };
};

export default useMail;
